import { Component, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../main/accountant/accountant.service";
import { DashboardService } from "../../dashboard.service";
import { ConversationsService } from "../conversations.service";
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { FormUtil } from "../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { InitialsDirective } from "../../../utils/initials.directive";
import { NgFor, NgClass, NgIf } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
    selector: "create-conversation-modal",
    templateUrl: "./create-conversation-modal.component.html",
    imports: [
        FormsModule,
        NgFor,
        NgClass,
        InitialsDirective,
        NgIf,
        TooltipModule,
    ]
})
export class CreateConversationModalComponent implements OnInit {
  clients: any = [];
  conversation_name: any;
  selectedClient: any = { users: [] };
  selectedUsers: any = [];
  selectedMembers: any = [];
  company: any;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private conversationsService: ConversationsService,
    private dashboardService: DashboardService,
    private localStorage: LocalStorageService,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.company = this.localStorage.get("company");
    console.log(this.company);
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.clients = changes.clients;
    if (this.clients.length > 0) {
      this.selectedClient = this.clients[0];
      this.selectedUsers = this.selectedClient.users;
      this.selectedUsers.forEach((u) => {
        u.selected = true;
      });
    }
  }

  toggleSelectedUser(user): void {
    user.selected = !user.selected;

    if (user.selected) {
      this.selectedUsers.push(user);
    } else {
      this.selectedUsers = this.selectedUsers.filter((u) => {
        return u.id !== user.id;
      });
    }
  }

  toggleSelectedMember(user): void {
    user.selected = !user.selected;

    if (user.selected) {
      this.selectedMembers.push(user);
    } else {
      this.selectedMembers = this.selectedMembers.filter((u) => {
        return u.id !== user.id;
      });
    }
  }

  changedClient(): void {
    this.selectedUsers = this.selectedClient.users;
    this.selectedUsers.forEach((u) => {
      u.selected = true;
    });
  }

  add_conversation(): void {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .add_conversation(
        this.conversation_name,
        this.selectedUsers,
        this.selectedMembers,
        this.selectedClient.id
      )
      .then(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          const response = res;
          console.log(response);

          this.conversationsService.conversation_added.next(
            response.conversation
          );

          this.bsModalRef.hide();
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          console.log(err);
        }
      );
  }
}
